import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { NgxCurrencyModule } from 'ngx-currency';

import { MaterialFeatureModule } from '../material-feature.module';

import {
  CheckboxComponent,
  ColorPickerComponent,
  DatepickerComponent,
  FormErrorListComponent,
  InputComponent,
  InputCurrencyComponent,
  MultipleInputComponent,
  RadioComponent,
  SwitchComponent,
  TextareaComponent
} from '@app/shared/modules/form-feature/components';

@NgModule({
  declarations: [
    InputComponent,
    FormErrorListComponent,
    RadioComponent,
    MultipleInputComponent,
    TextareaComponent,
    DatepickerComponent,
    CheckboxComponent,
    SwitchComponent,
    ColorPickerComponent,
    InputCurrencyComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    NgxCurrencyModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialFeatureModule
  ],
  exports: [
    InputComponent,
    FormErrorListComponent,
    RadioComponent,
    MultipleInputComponent,
    TextareaComponent,
    DatepickerComponent,
    CheckboxComponent,
    SwitchComponent,
    ColorPickerComponent,
    InputCurrencyComponent
  ]
})
export class FormFeatureModule {
}
